// src/components/Chatbot.js
import React, { useState } from 'react';

function Chatbot() {
    const [chatHistory, setChatHistory] = useState([]);
    const [userInput, setUserInput] = useState('');

    const sendMessage = async () => {
        if (!userInput) return;

        // Add user message to chat history
        const newHistory = [...chatHistory, { sender: 'user', message: userInput }];
        setChatHistory(newHistory);

        // Send message to chatbot API
        const response = await fetch('https://chatbot-vercel-5e4odz4c1-guivens-andres-projects.vercel.app/chat', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ user_input: userInput, chat_history: chatHistory })
        });
        const data = await response.json();

        // Add bot response to chat history
        setChatHistory([...newHistory, { sender: 'bot', message: data.response }]);
        setUserInput(''); // Clear the input field
    };

    return (
        <div style={{ padding: '20px' }}>
            <h2>Chat with Amie</h2>
            <div id="chatbox" style={{ width: '300px', height: '400px', overflowY: 'auto', border: '1px solid #ddd', padding: '10px' }}>
                {chatHistory.map((entry, index) => (
                    <div key={index} style={{ color: entry.sender === 'user' ? 'blue' : 'green', margin: '10px 0' }}>
                        <strong>{entry.sender === 'user' ? 'You' : 'Bot'}:</strong> {entry.message}
                    </div>
                ))}
            </div>
            <input
                type="text"
                value={userInput}
                onChange={(e) => setUserInput(e.target.value)}
                placeholder="Type your message here..."
                style={{ marginTop: '10px', width: '300px' }}
            />
            <button onClick={sendMessage} style={{ marginLeft: '10px' }}>Send</button>
        </div>
    );
}

export default Chatbot;
